import Vue from "vue";
import Component from "vue-class-component";
import highcharts from "highcharts";
import { Model, Prop } from "vue-property-decorator";

@Component
export class Chart extends Vue {
  @Prop()
  private chart!: highcharts.ChartOptions;
  private types = [
    "area",
    "arearange",
    "areaspline",
    "areasplinerange",
    "bar",
    "boxplot",
    "bubble",
    "column",
    "columnrange",
    "errorbar",
    "funnel",
    "gauge",
    "line",
    "pie",
    "polygon",
    "pyramid",
    "scatter",
    "solidgauge",
    "spline",
    "treemap",
    "waterfall"
  ];
}

@Component
export class Title extends Vue {
  @Prop({ default: "标题" })
  private header!: string;
  @Prop()
  private title!: highcharts.TitleOptions;
}

@Component
export class Series extends Vue{

  private test() {
    highcharts.chart({
      series: [],
    });
  }

}

@Component
export class XAxis extends Vue{
  @Prop()
  private xAxis!: highcharts.XAxisOptions[];

}
